import { useThemeStore } from './theme';
import { defineStore } from 'pinia';

/**
 * ！！！！！
 * 如果新增了key并且需要保存在storage中请在下方的unistorage.paths添加
 * ！！！！！
 */
const VersionKey = 'Order_AppVersion';
const system = defineStore('Order_System_Store', {
  state() {
    return {
      version: 'v1.0.1',
      // appid
      appid: '',
      // 主题ID
      themeId: 'default',
    };
  },
  getters: {

  },
  actions: {
    async updateAppConfig() {

    },
    /**
     * app更新 对比老版本和当前版本，可以做一些更新逻辑....
     */
    async updateApp() {
      const oldVersion = uni.getStorageSync(VersionKey);

      if (!oldVersion) {
        // 首次进入app
      } else if (oldVersion != this.version) {
        // 版本更新
      } else {
        // 版本相同
      }
      this.updateVersion(this.version);
      return true;
    },
    updateVersion(version: string) {
      this.version = version;
      uni.setStorageSync(VersionKey, this.version);
    },
    /**
 * 更新主题ID
 * @param id 主题ID
 */
    async updateThemeId(themeId?: string) {
      if (!themeId) themeId = this.companyId;
      this.themeId = themeId;
      useThemeStore().setTheme(themeId);
    },
  },
  unistorage: {
    paths: [],
  },
});

export default system;
